module.exports = __webpack_public_path__ + "static/media/map.243c9ff9.svg";